














































































import Vue from 'vue'
import Component from 'vue-class-component'
import OrderAPI from '@/api/orders'
import ProductAPI from '@/api/products'
import { IUserData } from '@/shared/models/auth'
import Loader from '@/components/common/Loader.vue'
import BezeButton from '@/components/common/BezeButton.vue'
import BezeInput from '@/components/common/BezeInput.vue'
import LoadStatusMessage from '@/components/common/LoadStatusMessage.vue'
import { ORDER_STATUS } from '@/shared/const'

@Component({
  components: {
    Loader,
    BezeButton,
    BezeInput,
    LoadStatusMessage
  }
})
export default class UserOrderList extends Vue {
  orderList: Array<any> = []
  isListLoading = true
  isSendReviewBtnLoading = false
  reviewMsg = ''

  data(): Record<string, unknown> {
    return {
      ORDER_STATUS
    }
  }

  get userData(): IUserData {
    return this.$store.getters.userData
  }

  created(): void {
    this.getUserOrderList()
  }

  getUserOrderList(): void {
    this.isListLoading = true
    OrderAPI.getUserOrders(this.userData.id).then(response => {
      this.orderList = response.data?.map(order => {
        order.isOpened = false
        order.isInfoLoading = true
        return order
      }).filter(order => order.meta_data.every((meta: Record<string, unknown>) => meta.key === '_new_order_email_sent'))
    }).catch(() => {
      this.$toasted.error('Не удалось получить список заказов, попробуйте обновить страницу')
    }).finally(() => {
      this.isListLoading = false
    })
  }

  openOrderInfo(order: any): void {
    order.isOpened = !order.isOpened
    if (order.isOpened) {
      order.isInfoLoading = true
      Promise.all(order.line_items?.map((product: any) => this.loadProductReview(product.product_id, order.id))).then(response => {
        // eslint-disable-next-line no-unused-expressions
        response?.forEach((review: any, index: number) => {
          order.line_items[index].reviews = review.filter((arr: any) => !Array.isArray(arr))
        })
      }).finally(() => {
        order.isInfoLoading = false
      })
    }
  }

  loadProductReview(productID: number, orderID: number): Promise<unknown> {
    return ProductAPI.getProductReview(productID, this.userData?.id, orderID, 'all').then(response => {
      return Promise.resolve(response.data)
    })
  }

  sendReview(product: any, order: any): void {
    this.isSendReviewBtnLoading = true
    ProductAPI.addReviewToProduct({
      orderID: order.id,
      id: product.product_id,
      review: product.reviewMsg,
      userID: this.userData?.id,
      name: `${this.userData?.first_name} ${this.userData?.last_name}`,
      email: this.userData?.email
    }).then(() => {
      product.reviewMsg = ''
      order.isOpened = false
      this.$toasted.success('Спасибо за отзыв! После модерации он появится на сайте')
    }).catch(() => {
      this.$toasted.error('При отправке произошла ошибка, попробуйте отправить еще раз')
    }).finally(() => {
      this.isSendReviewBtnLoading = false
    })
  }
}
